import { usePermissionStoreOutside } from '@/store/modules/permission'
// import { isDev } from '@/utils'
import type { Directive, DirectiveBinding } from 'vue'
/**
 * permission 权限指令
 * 指令用法：
 *  - 在需要控制 action 级别权限的组件上使用 v-permission="actionCode" , 如下：
 *    <a-button v-permission="02" >添加用户</a-button>
 *  - 在某些情况下，不适合使用 v-permission，只能通过手动设置 v-if 来实现, 如下：
 *    <a-button v-if="$permission(actionCode)">Button</a-button>
 *
 *  - 当前用户没有权限时，组件上使用了该指令则会被隐藏
 */

type ActionCodeType = string | string[]
export const isAuth = (code?: ActionCodeType): boolean => {
  const permissionStore = usePermissionStoreOutside()
  // if (isDev) return true
  if (!code) return true
  if (typeof code === 'string') {
    return permissionStore.menusKey.includes(code)
  } else {
    return code.some(item => permissionStore.menusKey.includes(item))
  }
}

const mounted = (el: Element, binding: DirectiveBinding<ActionCodeType>) => {
  !isAuth(binding.value) && el.parentNode?.removeChild(el)
}

const updated = (el: Element, binding: DirectiveBinding<ActionCodeType>) => {
  !isAuth(binding.value) && el.parentNode?.removeChild(el)
}

const authDirective: Directive = {
  mounted,
  updated
}
export default {
  install: app => {
    app.directive('permission', authDirective)
    !app.config.globalProperties.$permission &&
      Object.defineProperties(app.config.globalProperties, {
        $permission: {
          get() {
            return (code: ActionCodeType) => isAuth(code)
          }
        }
      })
  }
}

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $permission: (code?: string | string[]) => boolean
  }
}
